/**
 * File venue-finder-isotypo.js.
 *
 * venue finder customise script.
 *
 * 
 */

(function ($) {

  var $container = $('#venue-finder-isotope').isotope({
    itemSelector: '.item',
  });

  var $selects = $('#venue-finder-selectors select');

  $selects.change(function () {
    // map input values to an array
    var exclusives = [];
    var inclusives = [];
    // exclusive filters from selects
    $selects.each(function (i, elem) {
      if (elem.value) {
        exclusives.push(elem.value);
      }
    });
    // combine exclusive and inclusive filters

    // first combine exclusives
    exclusives = exclusives.join('');

    var filterValue;
    if (inclusives.length) {
      // map inclusives with exclusives for
      filterValue = $.map(inclusives, function (value) {
        return value + exclusives;
      });
      filterValue = filterValue.join(', ');
    } else {
      filterValue = exclusives;
    }

    $container.isotope({
      filter: filterValue
    });
  });

  var venueFinder = $('.venue-finder-search-inner');
  
  if (venueFinder.length) {
    var simpleSelect = new CustomSelect({
      elem: "event-size-select",
    });
    var simpleSelect = new CustomSelect({
      elem: "event-section-select",
    });
    var simpleSelect = new CustomSelect({
      elem: "event-district-select"
    });
  }


})(jQuery)